import React, { Fragment, useEffect, useState } from "react";
import "./index.scss";
import { setLanguage } from "../../module/config/config.action";
import { CONFIG } from "../../config/constant";
import Header from "../../component/Header";
import { useDispatch, useSelector } from "react-redux";
import { changeLanguage } from "../../i18";
import { translation } from '../../i18';

const Language = (props) => {
  const dispatch = useDispatch();
  const { t } = translation();
  const [languages, setLanguages] = useState([]);
  const [defaultLanguage, setDefaultLanguage] = useState('en');
  const { token } = useSelector((state) => state.auth);
  useEffect(() => {
    if (localStorage.getItem('language')) {
      setDefaultLanguage(localStorage.getItem('language'));
    }
    getContentList()
  }, []);

  async function getContentList(id) {
    const url = CONFIG.BASE_URL + `app/language`;
    let response = await fetch(url, {
      method: "GET",
      mode: "cors",
      cache: "no-cache",
      headers: {
        "Content-Type": "application/json",
        "Authorization": token
      },
    });
    if (response && response.status === 200) {
      response = await response.json();
      setLanguages(response);
    } else {
      response = await response.json();
    }
  }

  const selectLanguage = (e) => {
    setDefaultLanguage(e.target.value);
    localStorage.setItem('language', e.target.value);
    changeLanguage();
    dispatch(setLanguage(e.target.value));
  }

  return (
    <Fragment>
      <div className="setting-page">
        <Header />
        <div className="page-content">
          <div className="title">{t('languages')}</div>
          <ul className="language-list">
            {languages?.map(item => {
              return (
                <li className="language-list-item" key={item?.code}>
                  <label className="form-control">
                    <input type="radio" name="language" checked={defaultLanguage == item?.code ? true : false} value={item?.code} onChange={selectLanguage} />
                    <span>{item?.name}</span>
                  </label>
                </li>)
            })}
          </ul>
        </div>
      </div>
    </Fragment>
  );
};

export default Language;
